import { Link } from "@tanstack/react-router";
import { TriangleAlertIcon } from "lucide-react";
import { buttonVariants } from "../ui/button";
import { cn } from "@/lib/utils";

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="mx-auto max-w-md text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full">
          <span className="aspect-square rounded-full bg-red-100 p-4">
            <TriangleAlertIcon className="mb-0.5 size-10 text-xl text-red-500" />
          </span>
        </div>
        <h1 className="mb-3 text-3xl font-semibold tracking-tight text-gray-900 md:text-4xl">
          This page doesn’t exist.
        </h1>
        <p className="mb-8 text-gray-600">
          Double-check the URL or head back to the homepage.
        </p>

        <Link
          to="/"
          className={cn(
            buttonVariants({ variant: "outline" }),
            "border-gray-200 text-gray-700",
          )}
        >
          Go to Homepage
        </Link>
      </div>
    </div>
  );
}
